/* ══════════════════════════════════════════════════════════════════
   [D-770] «Чий це юзер» — ОДНА позначка на всі списки дашборда.

   OWNER 30.10: «зроби ту саму позначку в Квитанціях, Черзі і Відео».
   Ключове слово — «ту саму»: якби кожна сторінка малювала свій значок,
   через місяць вони б розійшлись у кольорі й у словах, і позначка
   перестала б щось підказувати з першого погляду. Тому і вигляд, і
   джерело даних, і кольори тут одні на всіх (кольори — ті самі, що на
   сторінці «🤝 Партнери», через спільний usePartnerColors).

   Дані — з легкої ручки `/api/partner-index` (лише ті, у кого є партнер),
   кеш на 5 хвилин і один запит на всі сторінки: «Черга» оновлюється
   кожні 3 секунди, і тягати заради двох полів повний список юзерів з
   агрегатами по відео — марна праця для сервера.
   ══════════════════════════════════════════════════════════════════ */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import api from '../api';
import { usePartnerColors } from './partnerColors';

const EMPTY = { byId: {}, byTg: {}, byUn: {}, ids: [], names: {} };
let cache = null, at = 0, loading = null;

function load() {
  if (cache && Date.now() - at < 300000) return Promise.resolve(cache);
  if (!loading) {
    loading = api.get('/partner-index').then(r => {
      const o = { byId: {}, byTg: {}, byUn: {}, ids: [], names: {} };
      (((r || {}).data || {}).rows || []).forEach(x => {
        const w = { uid: x.uid, pid: x.pid, name: x.name, cab: !!x.cab };
        if (x.uid) o.byId[x.uid] = w;
        if (x.tg) o.byTg[String(x.tg)] = w;
        if (x.un) o.byUn[String(x.un).toLowerCase()] = w;
        if (x.pid && o.ids.indexOf(x.pid) < 0) o.ids.push(x.pid);
        if (x.pid) o.names[x.pid] = x.name;
      });
      cache = o; at = Date.now(); return o;
    }).catch(() => { cache = cache || EMPTY; return cache; }).finally(() => { loading = null; });
  }
  return loading;
}

/** of(id юзера | telegram_id | '@нік') → { pid, name, cab } або null; color(pid) — колір партнера */
export function usePartnerIndex() {
  const [m, setM] = React.useState(cache || EMPTY);
  React.useEffect(() => { let dead = false; load().then(x => { if (!dead) setM(x); }); return () => { dead = true; }; }, []);
  const { color } = usePartnerColors(React.useMemo(() => m.ids.map(id => ({ id })), [m]));
  const of = (key) => {
    if (key === null || key === undefined || key === '') return null;
    return m.byId[key] || m.byTg[String(key)] || m.byUn[String(key).replace(/^@/, '').toLowerCase()] || null;
  };
  const nameOf = (pid) => m.names[pid] || ('партнер #' + pid);
  return { of, color, nameOf };
}

/** who — те, що повернув of(); без партнера малюємо порожнечу, а не «немає партнера» */
export function PartnerTag({ who, color, h }) {
  if (!who || !who.pid) return null;
  const name = who.name || ('партнер #' + who.pid);
  return (
    <Tooltip title={who.cab
      ? `Це САМ партнер «${name}» (акаунт його кабінету)`
      : `Учень партнера «${name}». Той самий юзер є і в картці партнера`}>
      <Chip size="small" data-ptag={who.pid} label={(who.cab ? '🧑‍💼 ' : '🤝 ') + name}
            sx={{ height: h || 17, fontSize: 10.5, fontWeight: 'bold', color: '#06120a', bgcolor: color(who.pid) }}/>
    </Tooltip>
  );
}
